import { LoginCredentials, LoginResponse } from '../types/admin';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Unified login that handles both admin and regular users
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
	const response = await fetch(`${API_BASE_URL}/auth/login`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(credentials),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Neuspešno prijavljivanje');
	}

	return response.json();
};

export const verifyToken = async (token: string): Promise<{ valid: boolean; user?: any }> => {
	const response = await fetch(`${API_BASE_URL}/auth/verify`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		return { valid: false };
	}

	const data = await response.json();
	return { valid: true, user: data.user };
};

// For backwards compatibility, export adminLogin as an alias
export const adminLogin = login;

// Email verification functions
export const validateVerificationToken = async (token: string): Promise<{ valid: boolean; user?: any }> => {
	const response = await fetch(`${API_BASE_URL}/auth/validate-token/${token}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Neuspešna validacija tokena');
	}

	return response.json();
};

export const verifyEmailAndSetPassword = async (token: string, password: string): Promise<{ success: boolean; message: string }> => {
	const response = await fetch(`${API_BASE_URL}/auth/verify-email`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			token,
			password,
		}),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Neuspešna verifikacija email-a');
	}

	return response.json();
};

// Forgot password function
export const forgotPassword = async (username: string): Promise<{ success: boolean; message: string }> => {
	const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			username,
		}),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Greška pri slanju zahteva za resetovanje lozinke');
	}

	return response.json();
};

// Reset password function
export const resetPassword = async (token: string, newPassword: string): Promise<{ success: boolean; message: string }> => {
	const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			token,
			newPassword,
		}),
	});

	if (!response.ok) {
		const error = await response.json();
		throw new Error(error.message || 'Greška pri resetovanju lozinke');
	}

	return response.json();
};
